import { t } from '@lib/i18n'
import { DiscountCardsState } from '@pages/Checkout/Discounts'

const DEFAULT_ICON = 'percent'

const ICONS: Record<string, string> = {
  PROMOCODE: 'gift',
  CORPORATECODE: 'percent',
  default: DEFAULT_ICON,
}

const getIcon = (code: string): string => ICONS[code] ?? ICONS.default

// ToDo: Remove this hardcoded logic inn the future
const ALTERNATIVE: Record<string, string> = {
  ANTT_Senior_100: 'ANTT_Senior_50',
}

function validateDiscountCards(
  discountCards: DiscountCard.Item[],
  inputCards: DiscountCardsState | null,
): Record<string, string> | null {
  /* istanbul ignore if */ // These conditions will never happen
  if (!discountCards?.length || !inputCards) return null

  const retailerOnlyDiscountsThatRequireCode = discountCards.filter(
    d => d.flowType === 'retailer_only' && d.requiresCode,
  )
  const firstInvalidRetailerOnlyDiscount = retailerOnlyDiscountsThatRequireCode.find(d => {
    const currentCode = inputCards[d.name]
    if (!currentCode) return false

    return currentCode.toLowerCase() !== d.name.toLowerCase()
  })

  if (firstInvalidRetailerOnlyDiscount) {
    return { [firstInvalidRetailerOnlyDiscount.name]: t('checkout.discounts.invalidCodeError') }
  }

  return null
}

const getCodeCard = ({ name }: DiscountCard.Item, code?: DiscountCode.Code): DiscountCode.Card => ({
  name,
  code,
})

const discountUtils = {
  getIcon,
  validateCards: validateDiscountCards,
  getCodeCard,
  ALTERNATIVE,
}

export default discountUtils
